import {Injectable} from '@angular/core';
import {
  BaseDaoService,
  ConfigService,
  handleError,
  User,
  UserEnterprisePermissions
} from '@q9elements/ui-kit/common';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class AuthDaoService extends BaseDaoService {
  fetchUserEnterprisePermissions(): Observable<UserEnterprisePermissions> {
    return this.http.get<UserEnterprisePermissions>(
      `${this.apiUrl}/account/enterprise/permissions`
    );
  }

  public updateProfile(id: string, data = {}): Observable<User> {
    return this.http
      .put<User>(`${ConfigService.environment.API_ENDPOINT}/users/${id}`, data)
      .pipe(handleError());
  }

  public validateRedirectUrl(redirectUrl: string, orgId: string): Observable<any> {
    return this.http
      .post(`${this.apiUrl}/auth/validate-redirect-url`, {redirectUrl, orgId})
      .pipe(handleError());
  }
}
